/* eslint-disable */
export default {
  attachFiles: 'Adjuntar archivo',
};

// @key: @#@"attachFiles"@#@ @source: @#@"Attach file"@#@
